import { redirect } from "@tanstack/react-router";
import { http } from "../shared/api/http.js";
import type { Role, SessionUser } from "@smartvow/shared";

/** `beforeLoad` : exige une session ; `role` la restreint ; force le changement de mot de passe. */
export function requireAuth(role?: Role) {
  return async () => {
    let user: SessionUser;
    try {
      user = (await http.get<{ user: SessionUser }>("/auth/me")).user;
    } catch {
      throw redirect({ to: "/login" });
    }
    if (user.mustChangePassword) throw redirect({ to: "/change-password" });
    if (role && user.role !== role) {
      throw redirect({ to: user.role === "admin" ? "/admin" : "/app" });
    }
    return { user };
  };
}
